<template>
  <div v-if="visible" class="kot-pwa" role="region" aria-label="Install KOT">
    <div class="kot-pwa__copy">
      <strong>{{ title }}</strong>
      <p>{{ message }}</p>
    </div>
    <div class="kot-pwa__actions">
      <button
        v-if="pwa.canInstall"
        type="button"
        class="kot-pwa__install"
        @click="install"
      >
        Install
      </button>
      <button type="button" class="kot-pwa__later" @click="dismiss">
        Not now
      </button>
    </div>
  </div>
</template>

<script>
import {
  pwaState,
  dismissInstallPrompt,
  promptPwaInstall,
} from '@/utils/pwa';

export default {
  name: 'PwaInstall',
  computed: {
    pwa() {
      return pwaState;
    },
    visible() {
      return this.pwa.enabled && !this.pwa.installed && !this.pwa.dismissed;
    },
    title() {
      if (!this.pwa.secure) return 'HTTPS is required to install KOT';
      if (this.pwa.ios) return `Add KOT to ${this.pwa.deviceLabel}`;
      return `Install KOT on ${this.pwa.deviceLabel}`;
    },
    message() {
      if (!this.pwa.secure) {
        return 'Open this KOT address with HTTPS. Then you can install it as a desktop app on the POS, or on a waiter phone or tablet.';
      }
      if (this.pwa.ios) {
        return 'Tap the Share button, then Add to Home Screen. The same install works on an iPhone or iPad.';
      }
      if (this.pwa.canInstall) {
        return 'Opens like an app on a POS computer, a waiter phone, or a waiter tablet. An admin can turn this off in KOT settings.';
      }
      return 'If Install is not offered yet, use the browser menu and choose Install app or Add to Home screen.';
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        document.documentElement.classList.toggle('kot-pwa-banner', !!value);
      },
    },
  },
  beforeDestroy() {
    document.documentElement.classList.remove('kot-pwa-banner');
  },
  methods: {
    install() {
      promptPwaInstall();
    },
    dismiss() {
      dismissInstallPrompt();
    },
  },
};
</script>

<style scoped>
.kot-pwa {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: calc(12px + env(safe-area-inset-top)) 16px 12px;
  padding-left: calc(16px + env(safe-area-inset-left));
  padding-right: calc(16px + env(safe-area-inset-right));
  background: var(--brand-primary, #512d82);
  color: #fff;
  text-align: left;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);
}

.kot-pwa__copy strong {
  display: block;
  font-size: 15px;
  font-weight: 600;
}

.kot-pwa__copy p {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.88);
}

.kot-pwa__actions {
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}

.kot-pwa__install,
.kot-pwa__later {
  border: 0;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.kot-pwa__install {
  background: #fff;
  color: var(--brand-primary, #512d82);
}

.kot-pwa__later {
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.45);
}

@media (max-width: 767px) {
  .kot-pwa {
    flex-direction: column;
    align-items: stretch;
  }

  .kot-pwa__actions {
    justify-content: flex-end;
  }
}

@media print {
  .kot-pwa {
    display: none !important;
  }
}
</style>
